import './index.css';
import 'url-polyfill/url-polyfill.js';
import { initDependencies, setupDependencies } from './app';

setupDependencies();

initDependencies();

const { runApp } = require('./services/runApp');
runApp();

/* eslint-disable */
if ((module as any).hot) {
  (module as any).hot.accept();
}
/* eslint-enable */
